import { getCodeTableAttribute } from "./codeTableAccess"
import { t } from "../../i18next"

export const houseLabelFor = house => {
  return house.description || (house.address && house.address.street)
}

export const cityLabelFor = itemWithCity => {
  return itemWithCity && [itemWithCity.zipCode, itemWithCity.city].join(" ").trim()
}

export const unitLabelFor = (unit, unitTypes) => {
  const unitTypeTitle = getCodeTableAttribute(unitTypes, unit.unitTypeCode, "title")
  if (unit.numberOfRooms) {
    return t("common.unitLabelWithRooms", { rooms: parseFloat(unit.numberOfRooms), type: unitTypeTitle })
  } else {
    return unitTypeTitle
  }
}

export const tenantLabelFor = ({ tenantName }) => {
  return tenantName || t("common.vacancy")
}



// WEBPACK FOOTER //
// ./src/features/common/presentationFormatters.js